








import { Component, Vue } from "vue-property-decorator";
import { IMG_NET_ERR } from "@/utils/const";
import { Empty } from "vant";
@Component({
  components: {
    [Empty.name]: Empty
  }
})
export default class TransferIntoHKIndex extends Vue {
  IMG_NET_ERR = IMG_NET_ERR;

  handleClick() {
    this.$emit("click");
  }
}
